import { Component } from '@angular/core';
import { PopoverInput, IDropdownItem } from '../base/popover-input';


@Component({
	selector: 'classification-code-dropdown',
	template: require('./classification-code-dropdown.component.html')
})
export class ClassificationCodeDropdownComponent extends PopoverInput {

	constructor() {

		super();

		this.items = [
			{ value: ' ', text: '' },
			{ value: 'A', text: 'A' },
			{ value: 'B', text: 'B' },
			{ value: 'C', text: 'C' }
		];

	}

	items: IDropdownItem[];

	get displayText() {
	
			const item = this.items.find(r => r.value === this.originalValue);

			if (item)
				return item.text;

			if (this.originalValue && item == null)
				return "!! " + this.dirtyValue;

			return "";
	}

	get selectedItem() {
		return this.items.find(r => r.value === this.dirtyValue);
	}

	set selectedItem(val: IDropdownItem) { this.dirtyValue = val.value; }

}




// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular2-router-loader/src!./TypeScript/shared/editable-popover/specialized/classification-code-dropdown.component.ts